export const selectAlertConfigs = (state) => state.alerts.configs;

export const selectRemainingAlertConfigs = (state) => state.alerts.remaining;

export const selectSubscriptionLevel = (state) => state.auth.subscriptionLevel;

export const selectSubscribed = (state) =>
  selectSubscriptionLevel(state) != null;

export const selectAuthenticated = (state) => state.auth.authenticated === true;

export const selectFullExportLink = (state) => state.auth.fullExportLink;
